import { EmptyState, PageHeader } from '@wit-support/ui';
import { LayoutGrid } from 'lucide-react';

/**
 * Корень `/`. Обычно сюда не попадают: охрана маршрута (`landingRedirect`)
 * сразу ведёт в первый доступный модуль. Экран остаётся для оператора, у
 * которого нет ни одного доступного раздела.
 */
export function Dashboard() {
  return (
    <div className="mx-auto flex max-w-[1200px] flex-col gap-6 p-4 sm:p-6 lg:p-8">
      <PageHeader title="Главная" />
      <EmptyState
        icon={LayoutGrid}
        title="Нет доступных разделов"
        description="У вашей роли пока нет доступа ни к одному разделу админки. Обратитесь к владельцу."
      />
    </div>
  );
}
